import axios from 'src/app-axios';
import Constants from 'src/constants';
import moment from 'moment';

export const devices = {
  namespaced: true,
  state: {
    workerLists: [],
    checkinType: null,
    activeCheckInDetails: {},
    projectsList: [],
    projectBudgets: [],
    projectIssues: [],
    budgetInstances: [],
    selectedWorkDetails: {},
    selectedInstanceDetails: null,
    workerDocVerificationStatus: {},
    organizationSettings: [],
    checkOutType: '',
    checkInId: {},
    previousCheckInDetails: {},
    latestWorkerCallLength: {},
  },
  getters: {
    getWorkerLists (state) {
      return state.workerLists;
    },
    getCheckInType (state) {
      return state.checkinType;
    },
    getCheckOutType (state) {
      return state.checkOutType;
    },
    getActiveCheckInDetails (state) {
      return state.activeCheckInDetails;
    },
    getProjectsList (state) {
      return state.projectsList;
    },
    getProjectBudgets (state) {
      return state.projectBudgets;
    },
    getProjectIssues (state) {
      return state.projectIssues;
    },
    getBudgetInstances (state) {
      return state.budgetInstances;
    },
    getSelectedWorkDetails (state) {
      return state.selectedWorkDetails;
    },
    getSelectedInstanceDetails (state) {
      return state.selectedInstanceDetails;
    },
    getWorkerDocVerifyStatus (state) {
      return state.workerDocVerificationStatus;
    },
    getOrganizationSettings (state) {
      return state.organizationSettings;
    },
    getCheckInId (state) {
    return state.checkInId;
    },
    getWorkTimerUpdatedAt (state) {
      return state.WorkTimerLastUpdatedAt;
    },
    getIssueStatus (state) {
      return state.issueStatus;
    },
    getPreviousCheckInDetails (state) {
     return state.previousCheckInDetails;
    },
    getLatestWorkerCallLength (state) {
     return state.latestWorkerCallLength;
    },
  },
  mutations: {
    setWorkersList (state, data) {
      state.latestWorkerCallLength = data.data;
      state.workerLists = [...state.workerLists, ...data.data];
    },
    setClearWorkerLists (state) {
      state.workerLists = [];
    },
    saveCheckInType (state, data) {
      state.checkinType = data;
    },
    saveCheckOutType (state, data) {
      state.checkOutType = data;
    },
    setActiveCheckInDetails (state, data) {
      state.activeCheckInDetails = data;
    },
    setProjectsList (state, data) {
      state.projectsList = data;
    },
    setProjectBudgets (state, budgets) {
      state.projectBudgets = budgets;
    },
    setProjectIssues (state, issues) {
      state.projectIssues = issues;
    },
    setBudgetInstances (state, instances) {
      state.budgetInstances = instances;
    },
    setSelectedWorkDetails (state, data) {
      state.selectedWorkDetails = data;
    },
    setSelectedInstanceDetails (state, details) {
      state.selectedInstanceDetails = details;
    },
    setWorkerDocVerifyStatus (state, status) {
      state.workerDocVerificationStatus = status;
    },
    setOrganizationSettings (state, data) {
      state.organizationSettings = data;
  },
  setCheckInId (state, details) {
    state.checkInId = details;
  },
  setWorkTimerUpdatedAt (state, dateTime) {
    state.WorkTimerLastUpdatedAt = dateTime;
  },
  setIssueStatus (state, data) {
    state.issueStatus = data;
  },
  clearWorkDetails (state) {
    state.selectedWorkDetails = {};
    state.selectedInstanceDetails = null;
  },
  setPreviousCheckInDetails (state, details) {
    state.previousCheckInDetails = details;
  },
  },
  actions: {
    async fetchWorkersList ({ dispatch, commit }, payload) {
      const url = `api/kiosks/app-users/lists/${payload.orgId}`;
      try {
        const response = await axios.get(url, payload.params);
        commit('setWorkersList', response.data);
      } catch (exception) {
        dispatch('alert/onAlert', {
          message: 'Something went wrong in getting workers list.',
          type: Constants.ALERT_TYPE_ERROR,
        }, { root: true });
        throw exception;
      }
    },
    clearWorkerLists ({ commit }) {
      commit('setClearWorkerLists');
    },
    async fetchUsersCurrentCheckInDetails ({ dispatch, commit }) {
      const url = 'api/kiosks/app-users/user-active-records';
      try {
        const details = await axios.get(url);
        commit('setActiveCheckInDetails', details.data);
      } catch (exception) {
        dispatch('alert/onAlert', {
          message: 'Something went wrong in getting the active check-in details.',
          type: Constants.ALERT_TYPE_ERROR,
        }, { root: true });
      }
    },
    saveCheckInDetails ({ commit }, payload) {
      commit('saveCheckInType', payload);
    },
    saveCheckOutMethod ({ commit }, payload) {
      commit('saveCheckOutType', payload);
    },
    async logout ({ dispatch }) {
      const url = 'api/kiosks/logout';
      try {
        await axios.post(url);
      } catch (exception) {
        dispatch('alert/onAlert', {
          message: 'Something went wrong in Log out',
          type: Constants.ALERT_TYPE_ERROR,
        }, { root: true });
      }
    },
    async workerLogout ({ dispatch }) {
      const url = 'api/kiosks/app-users/logout';
      try {
        await axios.post(url);
      } catch (exception) {
        dispatch('alert/onAlert', {
          message: 'Something went wrong in Log out',
          type: Constants.ALERT_TYPE_ERROR,
        }, { root: true });
      }
    },
    async fetchProjectsList ({ dispatch, commit }, payload) {
      const url = `api/kiosks/organizations/${payload.orgExtId}/projects`;
      try {
    const response = await axios.get(url);
    commit('setProjectsList', response.data);
      } catch (exception) {
        dispatch('alert/onAlert', {
          message: 'Something went wrong in getting projects list',
          type: Constants.ALERT_TYPE_ERROR,
        }, { root: true });
      }
    },
    async fetchProjectBudgets ({ dispatch, commit }, payload) {
      const url = `api/kiosks/projects/${payload.projectId}/budgets`;
      try {
        const budgets = await axios.get(url);
        commit('setProjectBudgets', budgets.data);
      } catch (exception) {
        dispatch('alert/onAlert', {
          message: 'Something went wrong in getting the project budgets list.',
          type: Constants.ALERT_TYPE_ERROR,
        }, { root: true });
        throw exception;
      }
    },
    async fetchProjectIssues ({ dispatch, commit }, payload) {
      const url = `api/kiosks/projects/${payload.projectId}/issues`;
      try {
        const issues = await axios.get(url, payload.paramData);
          commit('setProjectIssues', issues.data);
      } catch (exception) {
        dispatch('alert/onAlert', {
          message: 'Something went wrong in getting the project budgets list.',
          type: Constants.ALERT_TYPE_ERROR,
        }, { root: true });
          throw exception;
      }
    },
    async fetchBudgetInstances ({ dispatch, commit }, payload) {
      const url = `api/kiosks/budgets/${payload.budgetId}/instances`;
      try {
        const instances = await axios.get(url);
        commit('setBudgetInstances', instances.data);
      } catch (exception) {
        dispatch('alert/onAlert', {
          message: 'Something went wrong in getting the budget instances list.',
          type: Constants.ALERT_TYPE_ERROR,
        }, { root: true });
        throw exception;
      }
    },
    saveSelectedWorkDetails (context, details) {
      context.commit('setSelectedWorkDetails', details);
    },
    async verifyWorkDetail ({ dispatch }, payload) {
      const url = `api/kiosks/organizations/${payload.organizationExtId}/check-in/budget-verify`;
      try {
        await axios.post(url, payload.details);
      } catch (exception) {
        dispatch('alert/onAlert', {
          message: 'Something went wrong in verifying the work details.',
          type: Constants.ALERT_TYPE_ERROR,
        }, { root: true });
        throw exception;
      }
    },
    saveSelectedInstanceDetails (context, details) {
      context.commit('setSelectedInstanceDetails', details);
    },
    clearSelectedInstanceDetails (context) {
      const details = '';
      context.commit('setSelectedInstanceDetails', details);
    },
    clearSavedWorkDetails (context) {
      context.commit('clearWorkDetails');
    },
    async verifyDocuments ({ dispatch, commit }, payload) {
      const url = `api/devices/organizations/${payload.organizationExtId}/documents-verify`;
      try {
        const status = await axios.post(url);
        commit('setWorkerDocVerifyStatus', status.data);
      } catch (exception) {
        dispatch('alert/onAlert', {
          message: 'Something went wrong in verifying your documents.',
          type: Constants.ALERT_TYPE_ERROR,
        }, { root: true });
        throw exception;
      }
    },
    async fetchOrganizationSettings ({ dispatch, commit }, payload) {
      const url = `api/kiosks/organization-settings/${payload}`;
      try {
          const documents = await axios.get(url);
          commit('setOrganizationSettings', documents.data);
      } catch (exception) {
          dispatch('alert/onAlert', {
              message: 'Something went wrong in getting the documents.',
              type: Constants.ALERT_TYPE_ERROR,
          }, { root: true });
      }
  },
  async checkInUser ({ dispatch, commit }, payload) {
    const url = `api/kiosks/organizations/${payload.orgExtId}/app-users/checkin`;
    try {
      const response = await axios.post(url, payload.details);
      commit('setCheckInId', response.data);
    } catch (exception) {
      dispatch('alert/onAlert', {
        message: 'Something went wrong in check-in you to this location.',
        type: Constants.ALERT_TYPE_ERROR,
      }, { root: true });
      throw exception;
    }
  },
  async sendWorkDetails ({ dispatch }, payload) {
    const url = `api/kiosks/check-in/${payload.checkInId}/worker`;
    try {
      await axios.post(url, payload.details);
    } catch (exception) {
      dispatch('alert/onAlert', {
        message: 'Something went wrong in sending your your work details.',
        type: Constants.ALERT_TYPE_ERROR,
      }, { root: true });
      throw exception;
    }
  },
  async checkOutUser ({ dispatch }, payload) {
    const url = `api/kiosks/check-out/${payload.checkInId}`;
    try {
      await axios.post(url, payload.checkOutTime);
    } catch (exception) {
      dispatch('alert/onAlert', {
        message: 'Something went wrong in check-out you from this location.',
        type: Constants.ALERT_TYPE_ERROR,
      }, { root: true });
      throw exception;
    }
  },
  updateWorkTimer ({ commit }) {
    commit('setWorkTimerUpdatedAt', moment().toISOString());
  },
  saveIssueStatus (context, details) {
    context.commit('setIssueStatus', details);
  },
  async sendIssueStatus ({ dispatch }, payload) {
    const url = `api/kiosks/check-out/${payload.checkInId}/worker`;
    try {
      await axios.post(url, payload.statusDetails);
    } catch (exception) {
      dispatch('alert/onAlert', {
        message: 'Something went wrong in sending your work status.',
        type: Constants.ALERT_TYPE_ERROR,
      }, { root: true });
      throw exception;
    }
  },
  async fetchPreviousCheckInDetails ({ dispatch, commit }) {
    const url = 'api/kiosks/records/app-user/latest';
    try {
      const details = await axios.get(url);
      commit('setPreviousCheckInDetails', details.data);
    } catch (exception) {
      dispatch('alert/onAlert', {
        message: 'Something went wrong in fetching your latest check-in record.',
        type: Constants.ALERT_TYPE_ERROR,
      }, { root: true });
    }
  },
  async clearDocVerifyData ({ commit }) {
    const data = {};
    commit('setWorkerDocVerifyStatus', data);
  },
  },
};
